import React, { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import { useAppDispatch } from "../../store"
import { useSelector } from "react-redux"
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from "react-router-dom"
import DashboardIcon from '@mui/icons-material/Dashboard';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import GroupsIcon from '@mui/icons-material/Groups';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SettingsIcon from '@mui/icons-material/Settings';
import DescriptionIcon from '@mui/icons-material/Description';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BuildIcon from '@mui/icons-material/Build';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import WifiCalling3Icon from '@mui/icons-material/WifiCalling3';
import CableIcon from '@mui/icons-material/Cable';
import BusinessIcon from '@mui/icons-material/Business';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import ResetTvOutlinedIcon from '@mui/icons-material/ResetTvOutlined';
import DisplaySettingsOutlinedIcon from '@mui/icons-material/DisplaySettingsOutlined';
import StarBorder from '@mui/icons-material/StarBorder'
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import ApiIcon from '@mui/icons-material/Api';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import WidgetsIcon from '@mui/icons-material/Widgets';
import { Alert, Backdrop, Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, Menu, MenuItem, Select, Snackbar, Switch, TextField } from "@mui/material"
import axios from "axios"
import { logOut } from "../../utils/logOut"
import { ExpandLess, ExpandMore, SmartButton } from "@mui/icons-material";
import AssistantIcon from '@mui/icons-material/Assistant';
import TranslatedText from "../../utils/Translate";
import { ChangeLanguage } from "../../store/auth/authReducer"
import { languageOptions } from "../../utils/LanguageList";
import WebCall from "../../views/MainViews/WebCall/WebCall";
import { useSnackbar } from "../../utils/SnackbarContext";
import KeyIcon from '@mui/icons-material/Key';
import ChatWidget from "../../utils/ChatWidget";
import SchoolIcon from '@mui/icons-material/School';
import PhotoFilterIcon from '@mui/icons-material/PhotoFilter';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import DvrIcon from '@mui/icons-material/Dvr';
import SnowOverlay from "../../utils/SnowOverlay";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';

const drawerWidth = 270;

function checkLang(lang: string) {

  if (lang == 'en') {
    return true;
  }

  // Получаем данные из localStorage
  const translationCache = localStorage.getItem('translationCache');

  // Если данных нет, возвращаем false
  if (!translationCache) {
    return false;
  }

  try {
    // Парсим JSON из строки
    const translations = JSON.parse(translationCache);

    // Проверяем, есть ли хотя бы один ключ с указанным языковым суффиксом
    return Object.keys(translations).some(key => key.endsWith(`_${lang}`));
  } catch (error) {
    // Если возникла ошибка при парсинге JSON, возвращаем false
    console.error('Ошибка при парсинге translationCache:', error);
    return false;
  }
}



//Configuring the Main component to display MainViews components

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

//Configuring the AppBar component (on opening/closing)

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));


const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));


export default function Layout() {

  //get auth data from store
  const username = useSelector(
    (state: any) => state.auth.authData.username
  )
  const accesslevel = useSelector(
    (state: any) => state.auth.authData.accesslevel
  )

  const partner = useSelector(
    (state: any) => state.auth.authData.partner
  )

  const currentPage = useSelector(
    (state: any) => state.auth.authData.currentPage
  )

  const language = useSelector(
    (state: any) => state.auth.authData.language
  )

  const dispatch = useAppDispatch()


  const theme = useTheme();
  //sidebar open state
  const [open, setOpen] = React.useState(false);
  const [loadlang, setLoadlang] = React.useState(false);
  const [snow, setSnow] = React.useState(localStorage.getItem('snowEffect') === 'true' ? true : false);

  const [openCollapsedList, setOpenCollapsedList] = React.useState<any>([]);

  const handleCollapsedListOpen = (el: any) => {

    if (!openCollapsedList.includes(el)) {
      setOpenCollapsedList([...openCollapsedList, el]);
    }
    else {
      setOpenCollapsedList(openCollapsedList.filter((item: any) => item !== el));
    }
    console.log(openCollapsedList);

  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openSelect = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorElWebCall, setAnchorElWebCall] = React.useState(null);
  const openSelectWebCall = Boolean(anchorElWebCall);

  const handleClickWebCall = (event: any) => {
    setAnchorElWebCall((prev) => (prev ? null : event.currentTarget));
  };
  const handleCloseWebCall = () => {
    setAnchorElWebCall(null);
  };

  const { showSnackbar } = useSnackbar();

  const [openDialog, setOpenDialog] = React.useState(false);

  const [passData, setPassData] = React.useState({
    "id": "",
    "username": "",
    "partnerbank": "",
    "accesslevel": "",
    "lastname": "",
    "language": "",
    "firstname": "",
    "middlename": "",
    "email": "",
    "jobtitle": "",
    "businessphone": "",
    "mobilephone": "",
    "oldpassword": "",
    "password": ""
  });

  const passwordRules = React.useMemo(() => {
    const pw = passData?.password ?? "";
    return {
      length: pw.length >= 12,
      uppercase: /[A-Z]/.test(pw),
      digit: /[0-9]/.test(pw),
      special: /[^A-Za-z0-9]/.test(pw),
    };
  }, [passData?.password]);

  const isPasswordValid = Object.values(passwordRules).every(Boolean);

  async function fetchData(params: object = {}) {
    const id = localStorage.getItem('id')
    try {
      const response = await axios.get(`https://cardgarantsales.com/restapi/user/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Bearer " + localStorage.getItem('access_token')
        }, params: params
      })
      if (response.data !== null) {
        setPassData({
          ...response.data[0],
          "oldpassword": "",
          "password": ""
        })
      }

      console.log(response.data[0]);

    } catch (error: any) {
      console.log(error);
      if (error.code === "ERR_BAD_REQUEST") {
        logOut(dispatch)
      }
      else if (error.code === "ERR_NETWORK") {
        showSnackbar('ERROR NETWORK', 'error')
      }
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setPassData(prev => ({ ...prev, oldpassword: "", password: "" }));
    handleClose()
  };

  const [openSnackbar, setOpenSnackbar] = useState(false)

  const [snackbarType, setSnackbarType] = useState("")

  const handleCloseSnack = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  async function putData(data: any) {
    const id = localStorage.getItem('id')
    try {
      const response = await axios.put(`https://cardgarantsales.com/restapi/user/${id}`, {
        ...data

      }, {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Bearer " + localStorage.getItem('access_token')
        },
      })

      setSnackbarType('success')
      setOpenSnackbar(true)
      setPassData(prev => ({ ...prev, oldpassword: "", password: "" }))
    } catch (error: any) {
      setSnackbarType('error')
      setOpenSnackbar(true)
      console.log(error);
      if (error.message === "Request failed with status code 401") {
        logOut(dispatch)
      }
      else if (error.code === "ERR_NETWORK") {
        showSnackbar('ERROR NETWORK', 'error')
      }
    }
  }


  const handleChangeSnow = () => {
    const newSnowState = !snow;
    setSnow(newSnowState);
    if (newSnowState) {
      showSnackbar('Snow effect enabled', 'success');
      localStorage.setItem('snowEffect', newSnowState.toString());
    }
    else {
      showSnackbar('Snow effect disabled', 'success');
      localStorage.removeItem('snowEffect');
  };
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        {/* {snow &&
          <Box sx={{ position: 'absolute', width: '100%', height: '130px', overflow: 'hidden', top: 0, left: 0, pointerEvents: 'none', zIndex: 0 }}>
            <SnowOverlay />
          </Box>} */}
        <Toolbar style={{ display: "flex", justifyContent: "space-between", position: "relative" }}>
          <Box style={{ display: "flex", alignItems: "center" }}>
            {
              open ?
                <IconButton
                  onClick={handleDrawerClose}
                  sx={{ mr: 2 }}
                  color="inherit"
                  aria-label="open drawer">
                  <ChevronLeftIcon sx={{ fontSize: 30 }} />
                </IconButton>
                :
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                  sx={{ mr: 2 }}
                >

                  <MenuIcon />
                </IconButton>
            }
            {/* <Typography variant="h6" noWrap component="div">
              {window.location.hostname.includes('cardgarant') ? 'Card Garant' : 'Humanaised'}
            </Typography> */}
            <Box sx={{ position: "relative", display: "inline-block" }}>
              <Typography variant="h6" noWrap component="div">
                {window.location.hostname.includes('cardgarant') ? 'Card Garant' : 'Humanaised'}
              </Typography>

              {/* Новогодняя шапка */}
              {/* <Box
                sx={{
                  position: "absolute",
                  width: 32,         // регулируй размер
                  top: -12,          // позиция над текстом
                  right: -20,        // чуть справа
                  transform: "rotate(20deg)", // лёгкий наклон
                  pointerEvents: "none",
                }}
              >
                <svg viewBox="0 0 237 199" style={{ width: "100%", height: "auto" }} version="1.1" xmlns="http://www.w3.org/2000/svg" ><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0.1843137254901961" d="M 193 23 Q 198.6 23.1 201 27.5 L 193.5 36 L 193 23 Z " /><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0.1843137254901961" d="M 173.5 31 L 178 33.5 L 177.5 37 L 173.5 31 Z " /><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0.1843137254901961" d="M 215 31 Q 220.6 31.1 223 35.5 Q 224.5 43.5 219.5 45 L 204.5 47 L 209 41.5 L 215 31 Z " /><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0.1843137254901961" d="M 226 52 Q 231.9 51.1 234 55.5 L 235 60.5 L 231.5 65 L 216.5 68 L 207 62.5 L 208.5 61 L 218.5 60 L 225 56.5 L 226 52 Z " /><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0.1843137254901961" d="M 222.5 73 L 229 77.5 L 230 84.5 L 227.5 88 L 220.5 89 L 207.5 81 L 207 82.5 L 212 94.5 L 212 99.5 L 207.5 104 L 203.5 104 L 199 100.5 L 198 97 L 203 93.5 L 203 86.5 L 199 75.5 L 200.5 76 L 211.5 82 L 217.5 82 Q 222 79.5 222.5 73 Z " /><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0.1843137254901961" d="M 169.5 75 L 169 76.5 L 165 91.5 L 168.5 96 Q 171.5 95.1 170 99.5 L 169 103.5 Q 171.2 104.8 170 109.5 L 174 117.5 L 171.5 118 L 169 117 L 162 104.5 L 161 89.5 Q 163.1 80.1 169.5 75 Z " /><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0.1843137254901961" d="M 184.5 80 L 190 95.5 L 185.5 103 L 180.5 104 L 175 99.5 Q 173.5 95.1 176.5 96 L 179 93.5 L 184.5 80 Z " /><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0.1843137254901961" d="M 190.5 128 L 200 136.5 L 204 147.5 L 204 153.5 Q 202 164 195.5 170 L 187.5 175 L 179.5 177 L 44.5 177 L 36.5 175 L 27 168.5 L 28.5 168 L 33.5 170 L 172.5 170 Q 184.3 167.8 190 159.5 L 195 148.5 L 195 138.5 L 190.5 128 Z " /><path fill="rgb(0,0,0)" stroke="rgb(0,0,0)" stroke-width="1" opacity="0" d="M 0 0 L 237 0 L 237 199 L 0 199 L 0 0 Z M 183 16 L 181 17 L 178 21 L 178 33 L 167 24 L 160 24 Q 154 26 156 35 L 157 36 L 144 33 L 114 33 L 100 36 Q 80 42 68 54 Q 42 77 34 118 L 30 118 L 22 122 Q 14 128 11 139 L 11 149 L 15 159 L 33 173 L 45 177 L 180 177 L 188 175 L 196 170 Q 202 164 204 154 L 204 148 L 200 137 L 185 122 L 175 118 L 170 110 Q 171 105 169 104 L 170 97 L 175 97 L 175 100 L 181 104 L 186 103 L 191 95 Q 192 99 198 97 L 199 101 L 204 104 L 208 104 L 212 100 L 212 95 L 207 83 L 208 81 L 221 89 L 228 88 L 230 85 L 229 78 L 221 73 L 218 69 L 232 65 L 235 61 L 234 56 Q 232 51 226 52 L 225 48 L 220 45 Q 225 43 223 36 Q 221 31 216 31 L 214 28 L 210 24 Q 203 23 202 27 L 194 23 L 192 20 Q 191 15 183 16 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 161.5 40 L 163.5 43 L 161.5 40 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 153.5 44 L 156 44.5 L 153.5 45 L 153.5 44 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 146.5 45 L 145.5 47 L 146.5 45 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 159.5 45 L 162 45.5 L 159.5 46 L 159.5 45 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 144.5 53 L 148 57.5 L 144 54.5 L 144.5 53 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 150.5 58 L 153 58.5 L 150.5 59 L 150.5 58 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 156.5 59 L 159 59.5 L 156.5 60 L 156.5 59 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 162 60 L 164 60.5 L 162 61.5 L 162 60 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 160.5 62 L 159.5 64 L 160.5 62 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 153.5 66 L 152.5 68 L 153.5 66 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 150.5 68 L 148.5 71 L 150.5 68 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 168.5 74 L 167.5 76 L 168.5 74 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 161.5 78 L 160.5 80 L 161.5 78 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 153.5 81 L 157 81.5 L 153.5 82 L 153.5 81 Z " /><path fill="rgb(254,49,49)" stroke="rgb(254,49,49)" stroke-width="1" opacity="0.9607843137254902" d="M 35.5 117 L 170 117.5 L 35.5 118 L 35.5 117 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="0.996078431372549" d="M 117.5 33 L 121 33.5 L 117.5 34 L 117.5 33 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="0.996078431372549" d="M 135.5 33 L 139 33.5 L 135.5 34 L 135.5 33 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="0.996078431372549" d="M 80.5 45 L 79.5 47 L 80.5 45 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="0.996078431372549" d="M 77.5 47 L 76.5 49 L 77.5 47 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="0.996078431372549" d="M 74.5 49 L 72.5 52 L 74.5 49 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="0.996078431372549" d="M 69.5 53 L 60.5 63 L 69.5 53 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="0.996078431372549" d="M 58.5 65 L 56.5 68 L 58.5 65 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="0.996078431372549" d="M 167.5 76 L 166.5 78 L 167.5 76 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 182.5 16 Q 190.5 14.5 192 19.5 L 191.5 21 L 188.5 17 Q 182.4 16.3 180 18 L 179 20.5 L 179 38 L 176 36.5 L 178 36.5 L 178 20.5 L 180.5 17 L 182.5 16 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 159.5 24 L 161 24.5 L 157 27.5 L 156.5 30 L 156 27.5 L 159.5 24 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 165.5 24 L 173 30.5 L 174 32.5 L 172 31.5 L 166.5 25 L 165.5 24 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 205.5 24 Q 212.4 23.1 214 27.5 L 213.5 29 L 211.5 26 L 205.5 25 L 205.5 24 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 203.5 25 L 201.5 28 L 203.5 25 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 156.5 32 L 158 35.5 L 156 34.5 L 156.5 32 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 197.5 32 L 196.5 34 L 197.5 32 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 210.5 38 L 208.5 41 L 210.5 38 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 204.5 45 L 204.5 47 L 206 47.5 L 204.5 48 Q 201.5 46.5 204.5 45 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 223.5 46 Q 226.6 47.4 226 52.5 L 225 52.5 L 223.5 46 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 216.5 68 L 221 71.5 L 220.5 73 L 217.5 69 L 216.5 68 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 184.5 78 L 183.5 80 L 184.5 78 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 219.5 79 L 218.5 81 L 219.5 79 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 190.5 94 L 195 96.5 L 192.5 97 L 190.5 94 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 170.5 96 L 175 96.5 L 170.5 97 L 170.5 96 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 29.5 118 L 33 118.5 L 27.5 120 L 27.5 119 L 29.5 118 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 173.5 118 L 179 119.5 L 177.5 120 L 173.5 119 L 173.5 118 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 24.5 120 L 26 120.5 L 16.5 128 L 21.5 122 L 24.5 120 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 182.5 121 L 189 126.5 L 184.5 123 L 182.5 121 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 15.5 129 L 15 130.5 L 12.5 137 L 12 134.5 L 15.5 129 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 11.5 138 L 12 148.5 L 11 148.5 L 11.5 138 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 12.5 150 L 14 154.5 L 13 154.5 L 12.5 150 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 14.5 156 L 22.5 165 L 26 166.5 L 24.5 167 L 15 158.5 L 14.5 156 Z " /><path fill="rgb(249,249,249)" stroke="rgb(249,249,249)" stroke-width="1" opacity="0.6431372549019608" d="M 187.5 161 L 186.5 163 L 187.5 161 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 113.5 33 L 117 33.5 L 113.5 34 L 113.5 33 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 139.5 33 L 144 33.5 L 139.5 34 L 139.5 33 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 107.5 34 L 110 34.5 L 107.5 35 L 107.5 34 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 147.5 34 L 151 34.5 L 147.5 35 L 147.5 34 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 153.5 35 L 156 35.5 L 153.5 36 L 153.5 35 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 86.5 41 L 88 41.5 L 85.5 43 L 86.5 41 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 79.5 45 L 78.5 47 L 79.5 45 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 76.5 47 L 75.5 49 L 76.5 47 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 73.5 49 L 70.5 53 L 73.5 49 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 67.5 54 L 61.5 61 L 67.5 54 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 59.5 63 L 56.5 67 L 59.5 63 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 55.5 68 L 54 70.5 L 50.5 76 L 51 74.5 L 55.5 68 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 169.5 74 L 168.5 76 L 169.5 74 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 49.5 77 L 49 78.5 L 47.5 81 L 48 79.5 L 49.5 77 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 166.5 78 L 165.5 80 L 166.5 78 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 160.5 91 L 161 98.5 L 160 98.5 L 160.5 91 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 165.5 111 L 166.5 113 L 165.5 111 Z " /><path fill="rgb(236,0,0)" stroke="rgb(236,0,0)" stroke-width="1" opacity="0.3254901960784314" d="M 167.5 114 L 168.5 116 L 167.5 114 Z " /><path fill="rgb(255,0,0)" stroke="rgb(255,0,0)" stroke-width="1" opacity="1" d="M 121.5 33 L 144.5 34 L 155.5 36 L 161 39.5 L 166 45.5 L 162.5 46 L 155.5 44 L 148.5 44 L 145 46.5 L 144 54.5 L 150.5 59 L 162 60 Q 163.1 62.7 160.5 62 L 148 70.5 L 147 74.5 L 151.5 81 L 156.5 82 L 166.5 76 L 166 77.5 Q 158.8 84.8 160 100.5 L 168 117 L 35.5 117 L 35 115.5 Q 44.2 74.7 71.5 52 L 93.5 39 L 107.5 35 L 120.5 34 L 121.5 33 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 199.5 30 L 198.5 32 L 199.5 30 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 194.5 36 L 192.5 39 L 194.5 36 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 159.5 37 L 162.5 41 L 159.5 37 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 207.5 41 L 206.5 43 L 207.5 41 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 164.5 43 L 166.5 46 L 164.5 43 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 149.5 44 L 153 44.5 L 149.5 45 L 149.5 44 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 223.5 56 L 222.5 58 L 223.5 56 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 164.5 60 L 163.5 62 L 164.5 60 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 154.5 66 L 153.5 68 L 154.5 66 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 149.5 70 L 149 71.5 L 148.5 73 L 148 71.5 L 149.5 70 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 149.5 78 L 150.5 80 L 149.5 78 Z " /><path fill="rgb(255,254,254)" stroke="rgb(255,254,254)" stroke-width="1" opacity="1" d="M 187.5 126 L 188.5 128 L 187.5 126 Z " /><path fill="rgb(255,255,255)" stroke="rgb(255,255,255)" stroke-width="1" opacity="1" d="M 182.5 17 Q 189.5 15.5 191 19.5 L 192 21.5 L 192.5 39 L 204.5 25 Q 209.9 24.4 212 26 L 214 32.5 L 203 48 L 219.5 45 L 224 47 Q 225.6 49.1 225 54.5 L 219.5 59 L 208.5 60 L 205 61.5 L 220 71.5 L 221 76.5 L 217.5 81 L 213.5 82 L 197.5 73 L 197 74.5 L 203 90.5 L 200.5 95 L 195.5 97 L 191 94.5 L 184.5 78 L 176.5 95 L 170.5 96 L 167 93.5 L 166 87.5 L 172 73.5 L 169.5 73 L 160.5 79 L 153.5 81 L 149 77.5 L 148 73.5 L 150 69 L 165 60.5 L 150.5 58 L 145 54.5 L 144 51.5 L 146 46 Q 149 44 156.5 45 L 167 47 L 157 34.5 L 156 30.5 L 159.5 25 L 164.5 24 L 171 29.5 L 177.5 38 L 179 37.5 L 179 20.5 L 182.5 17 Z " /><path fill="rgb(255,255,255)" stroke="rgb(255,255,255)" stroke-width="1" opacity="1" d="M 33.5 118 L 172.5 118 Q 181.4 120.1 187 125.5 Q 192.2 130.3 194 138.5 L 194 149.5 Q 191.2 158.7 184.5 164 L 173.5 169 L 32.5 169 Q 21.6 166.4 16 158.5 Q 10.2 151.8 12 137.5 Q 14.5 129 20.5 124 Q 25.3 119.3 33.5 118 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 192.5 23 L 193.5 36 L 196 34.5 L 192 37.5 L 192.5 23 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 200.5 28 L 198.5 31 L 200.5 28 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 174.5 33 L 176.5 36 L 174.5 33 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 212.5 36 L 211.5 38 L 212.5 36 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 208.5 41 L 205.5 45 L 208.5 41 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 213.5 45 L 216 45.5 L 213.5 46 L 213.5 45 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 207.5 46 L 210 46.5 L 207.5 47 L 207.5 46 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 224.5 56 L 223.5 58 L 224.5 56 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 216.5 59 L 219 59.5 L 216.5 60 L 216.5 59 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 206 61 L 208 61.5 L 206 62.5 L 206 61 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 212.5 65 L 213.5 67 L 212.5 65 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 221.5 73 L 222 76.5 L 221 76.5 L 221.5 73 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 184.5 79 L 183.5 81 L 184.5 79 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 165.5 88 L 166 91.5 L 165 91.5 L 165.5 88 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 166.5 93 L 168.5 96 L 166.5 93 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 202.5 93 L 199.5 97 L 202.5 93 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 190.5 129 L 191.5 131 L 190.5 129 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 194.5 138 L 195 148.5 L 194 148.5 L 194.5 138 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 189.5 159 L 188.5 161 L 189.5 159 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 185.5 163 L 184.5 165 L 185.5 163 Z " /><path fill="rgb(191,190,190)" stroke="rgb(191,190,190)" stroke-width="1" opacity="0.5215686274509804" d="M 33.5 169 L 173 169.5 L 33.5 170 L 33.5 169 Z " /></svg>
              </Box> */}
            </Box>
          </Box>
          <Typography variant="h6" noWrap component="div">
            <TranslatedText key={currentPage} text={currentPage} />
          </Typography>
          <Box style={{ display: "flex", alignItems: "center" }}>
            <Typography mr={2} variant="h6" noWrap component="div">
              {username}
            </Typography>
            <IconButton
              onClick={handleClickWebCall}
              color="inherit">
              <WifiCalling3Icon />
            </IconButton>

            {openSelectWebCall && <Box sx={{
              position: "absolute",
              top: "75px",
              right: "20px",
              zIndex: 1300, boxShadow: 3,
              borderRadius: 2,
            }}><WebCall /></Box>}

            <IconButton
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              color="inherit">
              <SettingsIcon />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openSelect}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <FormControl sx={{ width: '100%', paddingX: 2 }} >
                <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Language"} /></InputLabel>
                <Select value={language} sx={{ width: '100%' }} onChange={(e: any) => { setLoadlang(true); dispatch(ChangeLanguage(e.target.value)); localStorage.setItem('targetlanguage', e.target.value); putData({ ...passData, 'language': e.target.value }); setTimeout(() => setLoadlang(false), 5000) }} labelId="simple-select-label" variant="standard" size="small" label={<TranslatedText text={"Language"} />} >
                  {languageOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Link style={{ textDecoration: "none", color: "#212121" }} to={`/user?id=${localStorage.getItem('id')}&type=profile`}>
                <MenuItem><TranslatedText text={"Profile"} /></MenuItem>
              </Link>
              <MenuItem onClick={handleClickOpenDialog}><TranslatedText text={"Change password"} /></MenuItem>
              <MenuItem sx={{ color: 'red' }} onClick={() => logOut(dispatch)}><TranslatedText text={"Log out"} /></MenuItem>
              {/* <MenuItem sx={{display: 'flex', justifyContent: 'center'}} onClick={handleChangeSnow}><AcUnitIcon fontSize="small" color="info" /> <Switch size="small" color="info" checked={snow}/></MenuItem> */}
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        {/* <DrawerHeader >
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader> */}
        {
          //check user accesslevel
          Number(accesslevel) === 1 ?
            <>
              <Divider />
              <List>
                <Link style={{ textDecoration: "none", color: "#212121" }} to="/partners">
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemIcon>
                        <AdminPanelSettingsIcon />
                      </ListItemIcon>
                      <ListItemText><TranslatedText text={"Partners"} /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
              </List>
              <Divider />
              <List>
                <Link style={{ textDecoration: "none", color: "#212121" }} to="/users">
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemIcon>
                        <AdminPanelSettingsIcon />
                      </ListItemIcon>
                      <ListItemText><TranslatedText text={"Users"} /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
              </List>
              <Divider />
              <List>
                <Link style={{ textDecoration: "none", color: "#212121" }} to="/loginreports">
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemIcon>
                        <ContactPageIcon />
                      </ListItemIcon>
                      <ListItemText><TranslatedText text={"Login Report"} /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
              </List>
              <Divider />
              <List>
                <Link style={{ textDecoration: "none", color: "#212121" }} to="/systemlog">
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemIcon>
                        <DvrIcon />
                      </ListItemIcon>
                      <ListItemText><TranslatedText text={"System Log"} /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                </Link>
              </List>
              <Divider />
            </>
            : Number(accesslevel) === 2 ?
              <>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/users">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <AdminPanelSettingsIcon />
                        </ListItemIcon>
                        <ListItemText><TranslatedText text={"Users"} /></ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/loginreports">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <ContactPageIcon />
                        </ListItemIcon>
                        <ListItemText><TranslatedText text={"Login Report"} /></ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/systemlog">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <DvrIcon />
                        </ListItemIcon>
                        <ListItemText><TranslatedText text={"System Log"} /></ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
              </>
              : Number(accesslevel) === 4 ?
              <>
                    <List>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/virtualassistant">
                        <ListItemButton>
                          <ListItemIcon>
                            <AssistantIcon />
                          </ListItemIcon>
                          <ListItemText primary={<TranslatedText text="Virtual assistant" />} />
                        </ListItemButton>
                      </Link>
                    </List>
                    <Divider />
                  </>
              :
              <>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <DashboardIcon />
                        </ListItemIcon>
                        <ListItemText>
                          <TranslatedText text="Dashboard" />
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleCollapsedListOpen('contacts')}>
                      <ListItemIcon>
                        {openCollapsedList.includes('contacts') ? <ExpandLess /> : <ExpandMore />}
                      </ListItemIcon>
                      <ListItemText>
                        <TranslatedText text="Contacts" />
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={openCollapsedList.includes('contacts')} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/contacts">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <ContactPageIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Contacts" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/contactgroups">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <GroupsIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Contact groups" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/contactreport">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <SummarizeIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Contact report" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                    </List>
                  </Collapse>
                </List>
                <Divider />
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/contacts">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <ContactPageIcon />
                        </ListItemIcon>
                        <ListItemText>Contacts</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/contactgroups">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <GroupsIcon />
                        </ListItemIcon>
                        <ListItemText>Contact groups</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/contactreport">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <SummarizeIcon />
                        </ListItemIcon>
                        <ListItemText>Contact report</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider /> */}
                <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleCollapsedListOpen('campaigns')}>
                      <ListItemIcon>
                        {openCollapsedList.includes('campaigns') ? <ExpandLess /> : <ExpandMore />}
                      </ListItemIcon>
                      <ListItemText><TranslatedText text="Campaigns" /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={openCollapsedList.includes('campaigns')} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/campaigns">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <ResetTvOutlinedIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Campaigns" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/dids">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <CableIcon />
                            </ListItemIcon>
                            <ListItemText>DIDs</ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      {/* {accesslevel === '5' && <Link style={{ textDecoration: "none", color: "#212121" }} to="/manualcampaign">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <DisplaySettingsOutlinedIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Manual campaign" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>} */}
                    </List>
                  </Collapse>
                </List>
                <Divider />
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/campaigns">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <ResetTvOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText>Campaigns</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                {accesslevel === '5' && <>
                  <List>
                    <Link style={{ textDecoration: "none", color: "#212121" }} to="/manualcampaign">
                      <ListItem disablePadding>
                        <ListItemButton>
                          <ListItemIcon>
                            <DisplaySettingsOutlinedIcon />
                          </ListItemIcon>
                          <ListItemText>Manual campaign</ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </List>
                  <Divider />
                </>} */}
                <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleCollapsedListOpen('calls')}>
                      <ListItemIcon>
                        {openCollapsedList.includes('calls') ? <ExpandLess /> : <ExpandMore />}
                      </ListItemIcon>
                      <ListItemText><TranslatedText text="Calls" /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={openCollapsedList.includes('calls')} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/calls">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <SettingsPhoneIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Calls" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/callreport">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <SummarizeIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Call report" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                    </List>
                  </Collapse>
                </List>
                <Divider />
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/calls">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <SettingsPhoneIcon />
                        </ListItemIcon>
                        <ListItemText>Calls</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/callreport">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <SummarizeIcon />
                        </ListItemIcon>
                        <ListItemText>Call report</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider /> */}
                <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleCollapsedListOpen('conversations')}>
                      <ListItemIcon>
                        {openCollapsedList.includes('conversations') ? <ExpandLess /> : <ExpandMore />}
                      </ListItemIcon>
                      <ListItemText><TranslatedText text="Conversations" /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={openCollapsedList.includes('conversations')} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversations">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <QuestionAnswerIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Conversations" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversationreport">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <SummarizeIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Conversation report" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversationdetails">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <DescriptionIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Conversation details" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                    </List>
                  </Collapse>
                </List>
                <Divider />
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversations">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <QuestionAnswerIcon />
                        </ListItemIcon>
                        <ListItemText>Conversations</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversationreport">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <SummarizeIcon />
                        </ListItemIcon>
                        <ListItemText>Conversation report</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversationdetails">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <DescriptionIcon />
                        </ListItemIcon>
                        <ListItemText>Conversation Details</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider /> */}
                <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleCollapsedListOpen('conversationtemp')}>
                      <ListItemIcon>
                        {openCollapsedList.includes('conversationtemp') ? <ExpandLess /> : <ExpandMore />}
                      </ListItemIcon>
                      <ListItemText><TranslatedText text="Conversation templates" /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={openCollapsedList.includes('conversationtemp')} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversationtemplates">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <AppRegistrationIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Conversation templates" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/settingsupconversationtemplates">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <BuildIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Setting up CT" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/prerecordedaudiosnippets">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <AudioFileIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Prerecorded audio snippets" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/synthaudiofragments">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <AudioFileIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Synthesized audio fragments" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/aiprompts">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <SmartButton />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="AI Prompts" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                       <Link style={{ textDecoration: "none", color: "#212121" }} to="/functions">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <BuildCircleIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Functions" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/wordgroups">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <ListAltIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Word groups" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/analysistemplates">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <ContentPasteSearchIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Analysis template" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/templateoptimization">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <FactCheckIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Reports for template optimization" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      {/* <Link style={{ textDecoration: "none", color: "#212121" }} to="/sattingsctvisuals">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <BuildIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Setting Up CT" /><br /><TranslatedText text="Visual Mode" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link> */}

                    </List>
                  </Collapse>
                </List>
                <Divider />
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversationtemplates">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <AppRegistrationIcon />
                        </ListItemIcon>
                        <ListItemText>Conversation templates</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/prerecordedaudiosnippets">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <AudioFileIcon />
                        </ListItemIcon>
                        <ListItemText>Prerecorded audio snippets</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/wordgroups">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <ListAltIcon />
                        </ListItemIcon>
                        <ListItemText>Word Groups</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/settingsupconversationtemplates">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <BuildIcon />
                        </ListItemIcon>
                        <ListItemText>Setting Up<br />Conversation Templ.</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider /> */}
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/sattingsctvisuals">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <BuildIcon />
                        </ListItemIcon>
                        <ListItemText>Setting Up CT<br />Visual Mode</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider /> */}
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/analysistemplates">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <ContentPasteSearchIcon />
                        </ListItemIcon>
                        <ListItemText>Analysis Template</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/dids">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <CableIcon />
                        </ListItemIcon>
                        <ListItemText>DIDs</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/userrequests">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <CableIcon />
                        </ListItemIcon>
                        <ListItemText>User Requests</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List> 
                <Divider />*/}
                <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleCollapsedListOpen('directories')}>
                      <ListItemIcon>
                        {openCollapsedList.includes('directories') ? <ExpandLess /> : <ExpandMore />}
                      </ListItemIcon>
                      <ListItemText><TranslatedText text="Directories" /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={openCollapsedList.includes('directories')} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {(accesslevel === '5' || partner == '80' || partner == '88' || partner == '13') &&
                        <Link style={{ textDecoration: "none", color: "#212121" }} to="/knowledgebases">
                          <ListItem disablePadding>
                            <ListItemButton sx={{ pl: 4 }}>
                              <ListItemIcon>
                                <SchoolIcon />
                              </ListItemIcon>
                              <ListItemText><TranslatedText text="Knowledge Base" /></ListItemText>
                            </ListItemButton>
                          </ListItem>
                        </Link>}
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/branches">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <LocationCityIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Branches" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/offices">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <BusinessIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Offices" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/loginreports">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <RecentActorsIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text="Login Report" /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/systemlog">
                        <ListItem disablePadding>
                          <ListItemButton sx={{ pl: 4 }}>
                            <ListItemIcon>
                              <DvrIcon />
                            </ListItemIcon>
                            <ListItemText><TranslatedText text={"System Log"} /></ListItemText>
                          </ListItemButton>
                        </ListItem>
                      </Link>
                    </List>
                  </Collapse>
                </List>
                <Divider />
                <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleCollapsedListOpen('api')}>
                      <ListItemIcon>
                        {openCollapsedList.includes('api') ? <ExpandLess /> : <ExpandMore />}
                      </ListItemIcon>
                      <ListItemText><TranslatedText text="API" /></ListItemText>
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={openCollapsedList.includes('api')} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/apikey">
                        <ListItemButton sx={{ pl: 4 }}>
                          <ListItemIcon>
                            <KeyIcon />
                          </ListItemIcon>
                          <ListItemText primary="API Key" />
                        </ListItemButton>
                      </Link>
                    </List>
                    <List component="div" disablePadding>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/apidocs">
                        <ListItemButton sx={{ pl: 4 }}>
                          <ListItemIcon>
                            <ApiIcon />
                          </ListItemIcon>
                          <ListItemText primary="API Docs" />
                        </ListItemButton>
                      </Link>
                    </List>
                  </Collapse>
                </List>
                <Divider />
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/branches">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <LocationCityIcon />
                        </ListItemIcon>
                        <ListItemText>Branches</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/offices">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <BusinessIcon />
                        </ListItemIcon>
                        <ListItemText>Offices</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider />
                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/loginreports">
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <RecentActorsIcon />
                        </ListItemIcon>
                        <ListItemText>Login Report</ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </Link>
                </List>
                <Divider /> */}
                {/* <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => handleCollapsedListOpen('docs')}>
                      <ListItemIcon>
                        {openCollapsedList.includes('docs') ? <ExpandLess /> : <ExpandMore />}
                      </ListItemIcon>
                      <ListItemText>Docs</ListItemText>
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={openCollapsedList.includes('docs')} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/apidocs">
                        <ListItemButton sx={{ pl: 4 }}>
                          <ListItemIcon>
                            <ApiIcon />
                          </ListItemIcon>
                          <ListItemText primary="API" />
                        </ListItemButton>
                      </Link>
                    </List>
                  </Collapse>
                </List>
                <Divider /> */}
                {
                  <>
                    <List>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/virtualassistant">
                        <ListItemButton>
                          <ListItemIcon>
                            <AssistantIcon />
                          </ListItemIcon>
                          <ListItemText primary={<TranslatedText text="Virtual assistant" />} />
                        </ListItemButton>
                      </Link>
                    </List>
                    <Divider />
                  </>
                }
                {
                  <>
                    <List>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/conversationanalytics">
                        <ListItemButton>
                          <ListItemIcon>
                            <AutoGraphIcon />
                          </ListItemIcon>
                          <ListItemText primary={<TranslatedText text="Conversation analitics" />} />
                        </ListItemButton>
                      </Link>
                    </List>
                    <Divider />
                  </>
                }
                {/* <List>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/knowledgebases">
                        <ListItemButton>
                          <ListItemIcon>
                            <TipsAndUpdatesIcon />
                          </ListItemIcon>
                          <ListItemText primary={<TranslatedText text="Knowledge bases" />} />
                        </ListItemButton>
                      </Link>
                    </List>
                    <Divider /> */}

                <>
                  <List>
                    <Link style={{ textDecoration: "none", color: "#212121" }} to="/userrequests">
                      <ListItem disablePadding>
                        <ListItemButton>
                          <ListItemIcon>
                            <AnnouncementIcon />
                          </ListItemIcon>
                          <ListItemText> {accesslevel === '5' ? <TranslatedText text="User requests" /> : <TranslatedText text="Support" />} </ListItemText>
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </List>
                  <Divider />
                </>

                {/* {accesslevel === '5' &&
                  <>
                    <List>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/aimodelaccesses">
                        <ListItemButton>
                          <ListItemIcon>
                            <PhotoFilterIcon />
                          </ListItemIcon>
                          <ListItemText primary={<><TranslatedText text="Permissions to LLM models" /></>} />
                        </ListItemButton>
                      </Link>
                    </List>
                    <Divider />
                  </>
                } */}

                <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/widgetbuilder">
                    <ListItemButton>
                      <ListItemIcon>
                        <WidgetsIcon />
                      </ListItemIcon>
                      <ListItemText primary={<TranslatedText text="Widget Builder" />} />
                    </ListItemButton>
                  </Link>
                </List>
                <Divider />
                {accesslevel === '5' &&
                  <>
                    <List>
                      <Link style={{ textDecoration: "none", color: "#212121" }} to="/prompter">
                        <ListItemButton>
                          <ListItemIcon>
                            <TipsAndUpdatesIcon />
                          </ListItemIcon>
                          <ListItemText primary={<><TranslatedText text="Prompter" /> (<TranslatedText text="Demo" />)</>} />
                        </ListItemButton>
                      </Link>
                    </List>
                    <Divider />
                  </>
                }
                {/* <List>
                  <Link style={{ textDecoration: "none", color: "#212121" }} to="/apidocs">
                    <ListItemButton>
                      <ListItemIcon>
                        <ApiIcon />
                      </ListItemIcon>
                      <ListItemText primary="API" />
                    </ListItemButton>
                  </Link>
                </List>
                <Divider /> */}

              </>

        }
      </Drawer>
      <Main open={open}>
        <DrawerHeader />
        <Box>
          {/* <ChatWidget /> */}
          <Outlet />
        </Box>
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle><TranslatedText text="Change password" /></DialogTitle>
          <DialogContent>
            <Box sx={{ width: '100%', display: "flex", justifyContent: "space-between", flexDirection: 'column', gap: 2, mt: 1, minWidth: 320 }}>
              <TextField type="password" value={passData.oldpassword} onChange={(e) => setPassData({ ...passData, oldpassword: e.target.value })} size="small" label={<TranslatedText text="Password" />} variant="outlined" />
              <TextField type="password" value={passData.password} onChange={(e) => setPassData({ ...passData, password: e.target.value })} size="small" label={<TranslatedText text="New password" />} variant="outlined" />

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                  {([
                    { key: 'length', label: 'Minimum 12 characters' },
                    { key: 'uppercase', label: 'At least one uppercase letter' },
                    { key: 'digit', label: 'At least one digit' },
                    { key: 'special', label: 'At least one special character' },
                  ] as { key: keyof typeof passwordRules; label: string }[]).map(({ key, label }) => (
                    <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Box sx={{
                        width: 8, height: 8, borderRadius: '50%',
                        backgroundColor: passwordRules[key] ? '#4caf50' : '#bdbdbd',
                        transition: 'background-color 0.3s',
                        flexShrink: 0,
                      }} />
                      <Typography variant="caption" sx={{ color: passwordRules[key] ? '#4caf50' : 'text.secondary', transition: 'color 0.3s' }}>
                        <TranslatedText text={label} />
                      </Typography>
                    </Box>
                  ))}
                </Box>

            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}><TranslatedText text="Cancel" /></Button>
            <Button
              disabled={!isPasswordValid || !passData.oldpassword}
              onClick={() => { putData(passData) }}
            ><TranslatedText text="Save" /></Button>
          </DialogActions>
          <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnack}>
            {snackbarType === 'error' ?
              <Alert onClose={handleCloseSnack} severity="error" sx={{ width: '100%' }}>
                <TranslatedText text="Saving error" />
              </Alert> :
              <Alert onClose={handleCloseSnack} severity="success" sx={{ width: '100%' }}>
                <TranslatedText text="Successfully saved" />
              </Alert>}
          </Snackbar>
        </Dialog>
        {<Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadlang && !checkLang(language)}
        >
          <CircularProgress color="inherit" />
        </Backdrop>}
      </Main>
    </Box>
  );
}